import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
  Typography,
  Grid,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PushPinIcon from "@mui/icons-material/PushPin";
import Notify from "../../../Notify";
import { getData, putData } from "../../../../services/library";
import InputMask from "react-input-mask";
import { UrlApi } from "../../../../services/apirest";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { registrarAccion, DONDE } from "../../logs/registrarAccion";

function CompletarDatosFacturacion(props) {
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [datosformulario, setDatosformulario] = useState(props.datosformulario);
  const [disBtn, setDisBtn] = useState(false);
  const [cliente, setCliente] = useState();
  const [dataCliente, setDataCliente] = useState({});
  const [sitIva, setSitIva] = useState(null);
  const [condiciones, setCondiciones] = useState(null);
  const [sucursales, setSucursales] = useState(null);
  const [sitIvaSeleccionada, setSitIvaSeleccionada] = useState("");
  const [condPagoSeleccionada, setCondPagoSeleccionada] = useState("");
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [tipo, setTipo] = useState(
    cliente?.tipo_doc_afip ? cliente.tipo_doc_afip : ""
  );
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  const obtenerCliente = () => {
    getData(
      "/envasado_clientes/xid/" + props.datosformulario.id_cliente,
      setCliente
    );
  };
  useEffect(() => {
    obtenerCliente();
  }, []);
  useEffect(() => {
    getData("/sucursales", setSucursales);
    getData("/condicion_pago", setCondiciones);
    getData("/condiciones_iva/envasado", setSitIva);
  }, [cliente]);

  useEffect(() => {
    setDataCliente({
      cuit: cliente && cliente[0] ? cliente[0].cuit : null,
      situacion_iva: cliente && cliente[0] ? cliente[0].situacion_iva : null,
      id_condicionpago:
        cliente && cliente[0] ? cliente[0].id_condicionpago : null,
      id_sucursal: cliente && cliente[0] ? cliente[0].id_sucursal : null,
      id_suc_cliente: cliente && cliente[0] ? cliente[0].id_sucursal : null,
      tipo_doc_afip: cliente && cliente[0] ? cliente[0].afip_tipodoc_cli : null,
    });
  }, [cliente]);

  useEffect(() => {
    // sitIva
    if (dataCliente?.situacion_iva !== "" && sitIva) {
      const sitEncontrada = sitIva.find(
        (d) => d.id === parseInt(dataCliente.situacion_iva)
      );
      if (sitEncontrada) {
        setSitIvaSeleccionada(sitEncontrada);
      }
    }
  }, [sitIva]);

  useEffect(() => {
    // cond Pago
    if (dataCliente?.id_condicionpago !== "" && condiciones) {
      const condicionEncontrada = condiciones.find(
        (d) => d.id === dataCliente.id_condicionpago
      );
      if (condicionEncontrada) {
        setCondPagoSeleccionada(condicionEncontrada);
      }
    }
  }, [condiciones]);

  useEffect(() => {
    // sucursal
    if (dataCliente?.id_sucursal !== "" && sucursales) {
      const sucursalEncontrada = sucursales.find(
        (d) => d.id === dataCliente.id_sucursal
      );
      if (sucursalEncontrada) {
        setSucursalSeleccionada(sucursalEncontrada);
      }
    }
  }, [sucursales]);

  const almacenar = (e) => {
    setDataCliente({
      ...dataCliente,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };

  async function guardarCliente(e) {
    setDisBtn(true);

    try {
      const response = await fetch(
        UrlApi + "/envasado_clientes/" + datosformulario.id_cliente,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cuit: dataCliente.cuit,
            id_sucursal: sucursalSeleccionada.id,
            situacion_iva: sitIvaSeleccionada.id,
            id_condicionpago: condPagoSeleccionada.id,
            tipo_doc_afip: dataCliente.tipo_doc_afip,
            factura_consfinal: dataCliente.factura_consfinal,
          }),
        }
      );

      const data = await response.json();

      if (response.ok && !data.code) {
        registrarAccion(
          DONDE.CLIENTES,
          `Completó datos de facturación del cliente ${datosformulario.id_cliente} (desde facturación): ` +
            `CUIT/DNI ${dataCliente.cuit}, Sit. IVA ${sitIvaSeleccionada.descripcion}, ` +
            `Cond. pago ${condPagoSeleccionada.condicion}, Sucursal ${sucursalSeleccionada.nombre}`
        );
        setNotificacion({
          open: true,
          mensaje: "Cliente actualizado correctamente",
          severity: "success",
          color: "success",
        });
        return { ok: true, data };
      } else {
        const mensaje =
          data?.sqlMessage || data?.mensaje || "Error al actualizar cliente";
        setNotificacion({
          open: true,
          mensaje,
          severity: "error",
          color: "error",
        });
        return { ok: false, data };
      }
    } catch (error) {
      console.error("Error al guardar cliente:", error);
      setNotificacion({
        open: true,
        mensaje: "Error de red al guardar cliente",
        severity: "error",
        color: "error",
      });
      return { ok: false, error };
    }
  }

  async function facturar(id) {
    try {
      const res = await fetch(
        UrlApi + "/envasado_pedidos/facturar/" + id + "/"+datosformulario.a_consfinal
      );
      const data = await res.json();
      if (res.ok) {
        registrarAccion(
          DONDE.FACTURACION,
          `Facturó pedido ${id} (cliente ${datosformulario.id_cliente})${datosformulario.a_consfinal === 1 ? " - a consumidor final" : ""}`
        );
      }
      return data;
    } catch (error) {
      console.error("Error al facturar:", error);
      return { error: "Error al facturar" };
    }
  }

  async function guardarYFacturar(e) {
    const respuestaGuardar = await guardarCliente(e);

    if (respuestaGuardar && respuestaGuardar.ok) {
      const respuestaFacturar = await facturar(datosformulario.id);
      setNotificacion({
        open: true,
        mensaje: "Cliente actualizado y pedido facturado correctamente",
        severity: "success",
        color: "success",
      });
      props.onClose();
    } else {
      setNotificacion({
        open: true,
        mensaje: "Error al guardar el cliente. No se pudo facturar.",
        severity: "error",
        color: "error",
      });
    }
  }

  useEffect(() => {
    if (sitIvaSeleccionada?.id === 4) {
      setDataCliente((prev) => ({
        ...prev,
        factura_consfinal: 1, // o 0, lo que necesites
      }));
    } else if (
      Object.keys(sitIvaSeleccionada).length !== 0 &&
      sitIvaSeleccionada?.id !== 4
    ) {
      setDataCliente((prev) => ({
        ...prev,
        factura_consfinal: 0, // o 0, lo que necesites
        tipo_doc_afip: 80,
      }));
    }
  }, [sitIvaSeleccionada]);

  useEffect(() => {
    const camposCompletos =
      dataCliente?.cuit &&
      dataCliente?.tipo_doc_afip !== undefined &&
      sitIvaSeleccionada?.id &&
      condPagoSeleccionada?.id &&
      sucursalSeleccionada?.id;
    setDisBtn(!camposCompletos);
  }, [
    dataCliente?.cuit,
    dataCliente?.tipo_doc_afip,
    sitIvaSeleccionada,
    condPagoSeleccionada,
    sucursalSeleccionada,
  ]);

  return (
    <div>
      <Typography textAlign={"center"}>
        Debe Completar los datos para poder facturar
      </Typography>
      <Grid container spacing={2} mt={0.5}>
        <Grid item xs={2}>
          {dataCliente.tipo_doc_afip !== undefined && (
            <Select
              name="tipo_doc_afip"
              labelId="Cuit/Dni"
              value={dataCliente.tipo_doc_afip}
              disabled={sitIvaSeleccionada?.id !== 4}
              // label="tipo_doc_afip"
              onChange={almacenar}
              size="small"
              fullWidth
              autoFocus
            >
              <MenuItem value={80}>Cuit</MenuItem>
              <MenuItem value={96}>Dni</MenuItem>
            </Select>
          )}
        </Grid>
        <Grid item xs={4}>
          {dataCliente.tipo_doc_afip === 80 ? (
            <Grid item xs={12}>
              <InputMask
                mask="99999999999"
                value={dataCliente.cuit}
                disabled={false}
                maskChar=" "
                onChange={almacenar}
              >
                {() => (
                  <TextField
                    size="small"
                    style={style}
                    type="text"
                    focused
                    name="cuit"
                    label="Numero Cuit"
                  />
                )}
              </InputMask>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <InputMask
                mask="99999999"
                value={dataCliente.cuit}
                disabled={false}
                maskChar=" "
                onChange={almacenar}
              >
                {() => (
                  <TextField
                    size="small"
                    style={style}
                    type="text"
                    focused
                    name="cuit"
                    label="Numero Dni"
                  />
                )}
              </InputMask>
            </Grid>
          )}
        </Grid>

        <Grid item xs={6}>
          <Autocomplete
            disabled={!sitIva}
            required
            disableClearable
            id="sitIva"
            style={style}
            size="small"
            noOptionsText={"Situación de IVA INEXISTENTE"}
            options={sitIva}
            autoHighlight
            getOptionLabel={(sit) => sit.descripcion}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            value={sitIvaSeleccionada || null}
            onChange={(event, value) => {
              setSitIvaSeleccionada(value);
            }}
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.id}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.descripcion}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                placeholder="Tipee para buscar..."
                {...params}
                label="Situación IVA"
                focused
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={6}>
          <Autocomplete
            disabled={!condiciones}
            required
            disableClearable
            id="id_condicionpago"
            style={style}
            size="small"
            noOptionsText={"Condición de Pago INEXISTENTE"}
            options={condiciones}
            autoHighlight
            getOptionLabel={(cond) => cond.condicion}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            value={condPagoSeleccionada || null}
            defaultValue={condPagoSeleccionada || null}
            onChange={(event, value) => {
              setCondPagoSeleccionada(value);
            }}
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.id}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.condicion}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                placeholder="Tipee para buscar..."
                {...params}
                label="Condición de Pago"
                focused
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={6}>
          <Autocomplete
            disabled={!sucursales}
            required
            disableClearable
            id="id_sucursal"
            style={style}
            size="small"
            noOptionsText={"Sucursal INEXISTENTE"}
            options={sucursales}
            autoHighlight
            getOptionLabel={(suc) => suc.nombre}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            value={sucursalSeleccionada || null}
            defaultValue={sucursalSeleccionada || null}
            onChange={(event, value) => {
              setSucursalSeleccionada(value);
            }}
            renderOption={(props, option) => (
              <Box
                component="li"
                key={option.id}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.nombre}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                placeholder="Tipee para buscar..."
                {...params}
                label="Sucursal"
                focused
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </Grid>
      </Grid>

      <Grid
        mt={1}
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Button
          variant="contained"
          onClick={() => props.onClose(false)}
          color="error"
        >
          Volver
        </Button>
        <Button
          disabled={disBtn}
          variant="contained"
          onClick={guardarYFacturar}
          color="success"
        >
          Guardar y Facturar
        </Button>
      </Grid>
      <Snackbar
        open={notificacion.open}
        autoHideDuration={4000}
        onClose={() => setNotificacion({ ...notificacion, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setNotificacion({ ...notificacion, open: false })}
          severity={notificacion.severity}
          sx={{ width: "100%" }}
        >
          {notificacion.mensaje}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default CompletarDatosFacturacion;
